module.exports = __webpack_public_path__ + "static/img/16038C_2_3_R_20200102_LC.4a539ef.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/raw_data/images/16038C_2_3_R_20200102_LC.png
// module id = HBqZ
// module chunks = 0